import _toConsumableArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";

/**
 * @file Created on Fri Jul 27 2018
 * @author VBr
 */
import { T } from '../../i18n/T';
import translate from '../../i18n/translate';
import StyledBreadcrumbs from './styled/Breadcrumbs';
import * as React from 'react';
import { Link } from 'react-router-dom';
/**
 * Function which return the breadcrumb links
 * @param navigation array of routes to match
 * @param path current page location
 */

var Breadcrumbs =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Breadcrumbs, _React$Component);

  function Breadcrumbs(props) {
    var _this;

    _classCallCheck(this, Breadcrumbs);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Breadcrumbs).call(this, props));
    _this.getLinks = _this.getLinks.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(Breadcrumbs, [{
    key: "render",
    value: function render() {
      var links = this.getLinks(this.props.navigation, this.props.path);

      if (this.props.title) {
        links.push(React.createElement("li", {
          key: translate(this.props.path)
        }, this.props.title));
      }

      return React.createElement(StyledBreadcrumbs, null, React.createElement("ul", null, links));
    }
  }, {
    key: "getLinks",
    value: function getLinks(navigation, path) {
      var _this2 = this;

      var links = [];
      navigation.forEach(function (route) {
        if (path.indexOf(translate(route.path)) !== -1 && path !== translate(route.path)) {
          links.push(route.empty || translate(route.path) === path && translate(route.path) !== '/' ? React.createElement("li", {
            key: translate(route.path)
          }, React.createElement(T, {
            id: route.name
          })) : React.createElement("li", {
            key: translate(route.path)
          }, React.createElement(Link, {
            to: translate(route.path)
          }, React.createElement(T, {
            id: route.name
          }))));
        }

        if (route.routes) {
          links.push.apply(links, _toConsumableArray(_this2.getLinks(route.routes, path)));
        }
      });
      return links;
    }
  }]);

  return Breadcrumbs;
}(React.Component);

export { Breadcrumbs as default };